// Modules
import React from "react";
import {
  GooglePlayLogo,
  AppStoreLogo,
  Storefront,
  Eye,
  EyeClosed,
  Cardholder,
} from "@phosphor-icons/react";

// Components
import WebsiteLayout from "../components/websiteLayout/index";

// Images
import mobileImage from "../images/explore.png";
import webImage from "../images/self-care.webp";
import { useState } from "react";
import { Toaster, toast } from "sonner";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha-enterprise";
import { navigate } from "gatsby";
import { useEffect } from "react";
import Loader from "../components/interface/Loaders/buttonLoader.jsx";
import { handleLoginRequest, handleVerificationRequest, resendOTPCode } from "../services/users.js";
import {
  getLastVisitedPage,
  setServiceList,
  setToken,
  setUser,
} from "../services/CurrentUser/currentUserLocalStorage.js";
import { currentUser } from "../services/CurrentUser/currentUserDetails.js";
import { getHasLoginStatus } from "../utilities/account-service-utils.js";
import { redirectToLoginPage } from "../utilities/redirect-to-login";
import { getData } from "../services/users.js";
import { formatJSON, sanitizeUserData } from "../utilities/text.utils.js";
import CompanyRegistrationOTPModal from "../components/model/Registration/company-registration-modal.jsx";

// Self service: Login
function SelfServiceLogin() {
  const isBrowser = typeof window !== `undefined`;
  const [formValue, setFormValue] = useState({
    username: "",
    password: "",
    accountType: "individual",
  });
  const [loader, setLoader] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [OTP, setOTP] = useState("");
  const [message, setMessage] = useState();
  const recaptchaRef = React.createRef();

  function handleToggler() {
    setToggler(!toggler);
  }
  let form = useRef(null);
  function validate() {
    form.current.reportValidity();
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  function handleClose() {
    setShowOTP(false);
  }
  function handleSubmitOTP() {
    try {
      handleVerificationRequest(
        username,
        OTP,
        accountType,
      ).then(res => {
        // console.log(res)
        if (res.success === true) {
          setLoader(false)
          toast.success(res.msg, {
            duration: 5000,
            position: "top-right",
          });

          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          if (isBrowser) {
            setLoader(false)
            toast.error(res.msg, {
              duration: 5000,
              position: "top-right",
            });
            // setShowToast(true)
            // setLoader(false)
            // setToaster({
            //   message: res.msg,
            //   icon: "toast-error",
            // })
          }
        }
      })
    } catch (error) {
      
    }
      setShowOTP(false);
  }

  function handleResendOTP() {
    try {
      resendOTPCode(
        username,
        accountType,
      ).then(res => {
        // console.log(res)
        if (res.success === true) {
          setLoader(false)
          toast.success(res.msg, {
            duration: 5000,
            position: "top-right",
          });
        } else {
          if (isBrowser) {
            setLoader(false)
            toast.error(res.msg, {
              duration: 5000,
              position: "top-right",
            });
            // setShowToast(true)
            // setLoader(false)
            // setToaster({
            //   message: res.msg,
            //   icon: "toast-error",
            // })
          }
        }
      })
    } catch (error) {
      
    }
      setShowOTP(false);
  }
  const { accountType, username, password } = formValue;

  const handleQuery = async (event) => {
    event.preventDefault();
    validate();
    setLoader(true);
    if (username === "" || password === "") {
      toast.error("All fields are required", {
        duration: 2000,
        position: "top-right",
      });
      setLoader(false);
      return null;
    }

    // const token = ""
    // const token = await recaptchaRef.current.executeAsync();

    handleLoginRequest(
      username,
      password,
      accountType
      //  token
    ).then((res) => {
      // console.log(res)
      if (res.success === true) {
        // console.log("BLOCK ONE");
        localStorage.setItem("hasLogin", true);
        currentUser(res.data, accountType);
        if (accountType === "company" && res.data[0]["VERIFY"] === "0") {
          // console.log("BLOCK TWO");
          handleResendOTP()
          setShowOTP(true);
          // toast.success(
          //   "A verification has been generated and sent to your contact number",
          //   { duration: 5000, position: "top-right" }
          // );

          // setTimeout(function () {
          //   if (isBrowser) {
          //     window.location.href =
          //       "https://play.telecel.com.gh/form/enterprise-verification/";
          //   }
          // }, 5000);
          setLoader(false);
        } else {
          // console.log("BLOCK THREE");
          toast.success(res.msg, { duration: 5000, position: "top-right" });
          setLoader(false);
          setSuccessToast(true);
        }
      } else {
        // console.log("BLOCK FOUR");
        if (isBrowser) {
          toast.error(
            !!res.msg
              ? res.msg
              : "There was a problem processing your request, please try again later",
            { duration: 5000, position: "top-right" }
          );
          setLoader(false);
        }
      }
    });
  };

  useEffect(() => {

    if (successToast === true) {
      if (accountType === "company") {;
        window.location.href = "/enterprise/";
        return;
      } else {
        window.location.href = "/dashboard/";
    
      }
    }
  }, [successToast]);

  useEffect(() => {
    getData()
      .then((res) => {
        // console.log(res)
        if (res?.data?.length) {
          const { data } = formatJSON(res) || {};
          // console.log(data)
          if (data) {
            // console.log(data)
            const { serviceList, hasLogin, token, user_Id, user } =
              sanitizeUserData(data);
            if (isBrowser) {
              const userToStore = {
                ContactEmail: user?.ContactEmail,
                ContactPhone: user?.ContactPhone,
                DefaultServiceID: user?.ID,
                DisplayName: user?.DisplayName,
                FirstName: user?.FirstName,
                LastName: user?.LastName,
                SecondaryID: user?.SecondaryID,
                msisdn: serviceList[0].primaryID,
                primaryID: user?.primaryID,
                serviceType: user?.Type,
                username: user_Id,
              };
              // currentUser(data, accountType)
              localStorage.setItem("hasLogin", hasLogin);
              setToken(token);
              setUser(userToStore);
              setServiceList({
                serviceList: serviceList,
              });
            }
            navigate("/dashboard");
          } else {
            // console.log(data)
            if (isBrowser) localStorage.removeItem("hasLogin");
            setServiceList({});
            setToken("");
            setUser({});
            // navigate("/");
          }
        } else {
          // console.log(data)
          if (isBrowser) localStorage.removeItem("hasLogin");
          setServiceList({});
          setToken("");
          setUser({});
          // navigate("/");
        }
      })
      .catch((error) => {
        if (isBrowser) localStorage.removeItem("hasLogin");
        setServiceList({});
        setToken("");
        setUser({});
        // navigate("/");
      });
  }, []);

  // Data

  // Render
  return (
    <WebsiteLayout pageView="login">
      <main className="container mx-auto pt-10">
        <div className="overflow-hidden bg-black text-center pt-10 pb-8 px-8 rounded-lg md:flex gap-10 w-full">
          <div className="hidden md:w-1/2 md:flex items-end justify-center relative -left-26 -bottom-8">
            <img src={webImage} alt="web" />
          </div>
          <div className="md:hidden border-b py-10 border-border_darker text-negative flex flex-col gap-5 justify-center items-center">
            <p className="text-heading_sm font-bold pb-2 text-negative">
              Welcome to Telecel Play Web
            </p>
            <div className="text-center">
              {" "}
              Pay for your postpaid bills and broadband services here.
            </div>
            <button
              onClick={() => navigate("/pay/")}
              className="rounded-full flex gap-5 items-center justify-center hover:bg-red_600 bg-brand text-telecel_white w-full px-4 py-3"
            >
              <Cardholder size="30px" color="#ffffff" />
              <p className="text-left text-subtitle">Pay Bills</p>
            </button>
          </div>
          <div className="md:w-1/2 pt-8 md:px-10">
            <p className="text-heading_sm font-bold pb-2 text-negative">
              Login to Telecel Play
            </p>
            <p className=" text-body_base text-negative">
              {" "}
              Don't have an account?{" "}
              <a
                href="/register/"
                className="text-negative text-body_base underline font-bold"
              >
                Register Here
              </a>
            </p>
            <form
              className="my-10 text-left"
              ref={form}
              onSubmit={handleQuery}
              action="/"
              method="POST"
            >
              <div className="my-8">
                <label className="font-bold text-negative text-body_base">
                  Select Account Type
                </label>
                <span className="text-brand"> *</span>
                <br />
                <select
                  placeholder="Select account type"
                  className="outline-none mt-1 text-black w-full py-3 px-2 border border-border_default bg-surface_subtle flex rounded-lg"
                  name="accountType"
                  value={accountType}
                  onChange={handleChange}
                >
                  <option value="individual">Individual</option>
                  <option value="company">Company</option>
                </select>
              </div>

              <div className="my-8">
                <label className="font-bold text-negative text-body_base">
                  Username/User ID/Telephone Number
                </label>
                <span className="text-brand"> *</span>
                <br />
                <input
                  className="outline-none mt-1 text-black w-full py-3 px-2 border border-border_default bg-surface_subtle flex rounded-lg"
                  placeholder="Textfield"
                  type="text"
                  name="username"
                  value={username}
                  onChange={handleChange}
                />
              </div>
              <div className="my-8">
                <label className="font-bold text-negative text-body_base">
                  Password
                </label>
                <span className="text-brand"> *</span>
                <br />
                <div className="border mt-1 border-border_default bg-surface_subtle flex rounded-lg">
                  <input
                    placeholder="XXXXXXX"
                    className="mt-1 outline-none pl-3 text-black w-full bg-surface_subtle rounded-lg py-3 px-2"
                    type={toggler ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={handleToggler}
                    className="flex items-center justify-center px-2 outline-none fill-body"
                  >
                    {toggler ? (
                      <Eye size={24} color="" />
                    ) : (
                      <EyeClosed size={24} color="" />
                    )}
                  </button>
                </div>
              </div>
              <button
                disabled={loader === true}
                type="submit"
                className="text-negative text-subtitle w-full rounded-full bg-surface_brand hover:bg-gray_700 text-center py-4"
              >
                {loader && <Loader />} Login
              </button>
              <div className="text-center pt-6 pb-10">
                <a
                  href="/reset-password/"
                  className="text-white underline font-semibold"
                >
                  Forgot your password?
                </a>
              </div>
            </form>
            <div className="hidden border-t pt-10 border-border_darker text-negative md:flex flex-col gap-5 justify-center items-center">
              <div className="text-center">
                {" "}
                Pay for your postpaid bills and broadband services here.
              </div>
              <button
                onClick={() => navigate("/pay/")}
                className="rounded-full flex gap-5 items-center justify-center hover:bg-red_600 bg-brand text-telecel_white w-full px-4 py-3"
              >
                <Cardholder size="30px" color="#ffffff" />
                <p className="text-left text-subtitle">Pay Bills</p>
              </button>
            </div>
          </div>
          <div className="md:hidden flex justify-center relative -bottom-8">
            <img src={mobileImage} alt="mobile" />
          </div>
        </div>

        {/* <div className="mt-12 md:mt-16 mb-16 md:mb-25">
          <div className="pb-6 md:pb-7">
            <h2 className="text-heading_sm pb-3 font-bold text-brand">
              Pay your broadband, fixed, hybrid, and Enterprise account bills.
            </h2>
            <p className="text-body_base">
              Pay your bills for your broadband, fixed and hybrid account bills,
              utility and other bills in one click.
            </p>
          </div>
          <div className="flex flex-col md:flex-row md:w-1/4 gap-4">
            {quickActions.map((action) => (
              <button
                onClick={() => navigate(action.link)}
                className="rounded-lg flex gap-5 items-center justify-center hover:bg-red_600 bg-brand text-telecel_white w-full px-4 py-4"
              >
                {action.icon}
                <p className="text-left">{action.title}</p>
              </button>
            ))}
          </div>
        </div> */}
        <Toaster richColors />
      </main>
      {/* <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.SITE_KEY}
        size="invisible"
        action="login"
      /> */}
       {showOTP && (
        <CompanyRegistrationOTPModal
          OTP={OTP}
          message={message}
          setOTP={setOTP}
          username={username}
          loader={loader}
          handleOnclick={handleSubmitOTP}
          handleClose={handleClose}
          handleOnclick2={handleResendOTP}
        />
      )}
    </WebsiteLayout>
  );
}

// Export
export default SelfServiceLogin;

export const Head = () => <title>Telecel Play Login</title>;
